import { Injectable } from '@angular/core';
import * as Constants from '@app/constants';
import { PRAGMAPOWER_LABELS } from '@app/constants/messages/ui-text.constants';

@Injectable({ providedIn: 'root' })
export class ConstantsService {
  readonly app = Constants;
  readonly PRAGMAPOWER_LABELS = PRAGMAPOWER_LABELS;
}

